import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/styles/index.css';
import '@/assets/iconfont/iconfont.css';
import '@unocss/reset/tailwind.css';
import 'virtual:uno.css';
import 'virtual:svg-icons-register';

const meta = document.createElement('meta');
meta.name = 'naive-ui-style';
document.head.appendChild(meta);

createApp(App)
  .use(router)
  .use(store)
  .mount('#app');
